import { Badge, Button } from "@heroui/react";
import { toast } from "sonner";
import { useAccount } from "wagmi";
import { deployL1Token } from "../../actions/deployToken";

export function NewL1TokenButton() {
  const isDevMode = import.meta.env.DEV;
  const { isConnected } = useAccount();

  if (!isDevMode) {
    return null;
  }

  return (
    <Badge color="danger" size="sm" showOutline={false} content="DEV">
      <Button
        onPress={async () => {
          if (!isConnected) {
            toast.error("Please connect your wallet first");
            return;
          }
          const tokenAddr = await deployL1Token();
          toast.info(`Deployed token at ${tokenAddr}`);
        }}
      >
        New token
      </Button>
    </Badge>
  );
}
